import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index/index'

Vue.use(Router)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [	
		{
			path: '/',
			redirect: "/index"
		},
		{
			path: '/index',
			name: 'index',
			component: index
		},
		{
			path: '/course',
			name: 'Course',
			component: () => import('@/view/course/list')
		},
		{
			path: '/means',
			name: 'Means',//49资料领取
			component: () => import('@/view/course/means.vue')
		},
		{
			path: '/details',
			name: 'Details',
			component: () => import('@/view/course/details')
		},
		{
			path: '/order',
			name: 'Order',
			component: () => import('@/view/order/order.vue')
		},
		{
			path: '/group',
			name: 'Group',
			component: () => import('@/view/order/group.vue')
		},
		{
			path: '/integral',
			name: 'Integral',
			component: () => import('@/view/order/integral.vue')
		},
		{
			path: '/live',
			name: 'Live',
			component: () => import('@/view/live/index.vue')
		},
		{
			path: '/replay',
			name: 'Replay',
			component: () => import('@/view/live/replay.vue')
		},
		{
			path: '/book',
			name: 'Book',
			component: () => import('@/view/book/index.vue')
		},
		{
			path: '/ebook',
			name: 'EBook',
			component: () => import('@/view/book/details.vue')
		},
		{
			path: '/bookOrder',
			name: 'BookOrder',
			component: () => import('@/view/book/integral.vue')
		},
		{
			path: '/topic',//52
			name: 'Topic',
			component: () => import('@/view/answer/topic.vue')
		},
		{
			path: '/subject',//53
			name: 'Subject',
			component: () => import('@/view/answer/subject.vue')
		},
		{
			path: '/result',//答题结果
			name: 'Result',
			component: () => import('@/view/answer/result.vue')
		},
		{
			path: '/wrong',//58 错题本
			name: 'Wrong',
			component: () => import('@/view/answer/wrongBook.vue')
		},
		{
			path: '/analysis',//58 错题本
			name: 'Analysis',
			component: () => import('@/view/answer/analysis.vue')
		},
		{
			path: '/feedBack',//66 学员心得
			name: 'FeedBack',
			component: () => import('@/view/answer/feedBack.vue')
		},
		{
			path: '/feedDetail',//67 学员心得详情
			name: 'FeedDetail',
			component: () => import('@/view/answer/feedDetail.vue')
		},
		{
			path: '/study',//68 学习中心
			name: 'Study',
			component: () => import('@/view/studyCenter/index.vue')
		},
		{
			path: '/score',//73 积分签到
			name: 'Score',
			component: () => import('@/view/jifen/index.vue')
		},
		{
			path: '/vip',//82 会员中心
			name: 'Vip',
			component: () => import('@/view/vip/index.vue')
		},
		{
			path: '/my',//84 我的资料
			name: 'My',
			component: () => import('@/view/my/index.vue')
		},
		{
			path: '/message',//84 我的资料
			name: 'Message',
			component: () => import('@/view/my/message.vue')
		},
		{
			path: '/content',//关于我们
			name: 'Content',
			component: () => import('@/view/content/index.vue')
		}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js